<template>
  <a-list
    class="container"
    itemLayout="horizontal"
    :grid="{ gutter: 10, xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }"
  >
    <template v-for="r in restaurants">
      <a-list-item class="items" :key="r.restaurantId">
        <restaurant-card
          :restaurantId="r.restaurantId"
          :restaurantName="r.restaurantName"
          :address="r.address"
          :postNumber="r.postNumber"
          :city="r.city"
          :fromTime="r.fromTime"
          :toTime="r.toTime"
          :imageUrl="r.imageUrl"
          :phoneNumber="r.phoneNumber"
          :isClosed="r.isClosed"
          @buttonPressed="handleSelected"
        />
      </a-list-item>
    </template>
  </a-list>
  <!--   <a-list class="container" :grid="{ gutter: 16, column: 4}"></a-list> -->
</template>

<script>
import RestaurantCard from "../cards/RestaurantCard";

export default {
  name: "RestaurantsList",
  props: {
    restaurants: { type: Array }
  },
  components: {
    RestaurantCard
  },
  methods: {
    handleSelected(e) {
      //console.log(e)
      this.$emit("restaurantSelected", e);
    }
  }
};
</script>

<style lang="scss" scoped>
$desktop: 1200px;
$laptop: 1024px;
$tablet: 768px;
$mobile: 480px;

.items {
  padding: 1rem;
  justify-content: center;
  @media (max-width: $laptop) {
    width: 100%;
  }
}
</style>
